import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { Store } from 'redux';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Category, DefinitionSummary } from '../insight/config.insight.model';
import {
    rootListDefinitionSummary,
    rootSelectLevelOption,
} from '../insight/insight.action';
import { PopUpService } from '../insight/pop-up.service';
import { storeObserver } from '../store';
import { STORE } from '../store.metadata';

import { TranslationKeyMap } from './performance-insight.i18n';
import { createTab } from './performance-insight.model';
import { RootState, storeStateMapper } from './performance-insight.state';

@Component({
    selector: '[cmpsPerformanceInsightWizard]',
    templateUrl: './wizard.pi.component.html',
})
export class WizardPerformanceInsightComponent implements OnInit {
    i18n = TranslationKeyMap;
    private _storeSub: Subscription;
    state: RootState;

    constructor(
        private readonly _ngZone: NgZone,
        @Inject(STORE) private readonly _store: Store,
        private readonly _popUpService: PopUpService,
    ) {}

    ngOnInit(): void {
        this._storeSub = storeObserver<any, RootState>(
            this._store,
            storeStateMapper,
        )
            .pipe(
                tap((state) =>
                    this._ngZone.run(() => {
                        const prevState = this.state;
                        this.state = state;
                        this.stateToProps(prevState);
                    }),
                ),
            )
            .subscribe();
    }

    stateToProps(prevState?: RootState): void {
        if (!prevState) {
            this.propsToDispatch();
            // eslint-disable-next-line no-useless-return
            return;
        }
    }

    propsToDispatch(): void {
        this._store.dispatch(rootListDefinitionSummary(['pi']));
    }

    onCategoryChange($event: Category): void {
        this._store.dispatch(rootSelectLevelOption($event, null, null));
    }

    onSubCategoryChange($event: Category): void {
        this._store.dispatch(rootSelectLevelOption(null, $event, null));
    }

    onDefinitionChange($event: DefinitionSummary): void {
        this._store.dispatch(rootSelectLevelOption(null, null, $event));
    }

    onAddClick(): void {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        this._popUpService.active &&
            this._popUpService.active.close(
                createTab(
                    this.state.activeDefinition.definitionIdentifier,
                    this.state.activeCategory.name ||
                        this.state.activeCategory.shortName,
                    this.state.activeSubCategory &&
                        (this.state.activeSubCategory.name ||
                            this.state.activeSubCategory.shortName),
                    this.state.activeDefinition.name ||
                        this.state.activeDefinition.shortName,
                ),
            );
    }
}
